module.exports = __webpack_public_path__ + "assets/img/ubuntu-big.be10a4eb.svg";